import Image from "next/image";
import HeaderComponent from "../components/Header";
import NavigationComponent from "../components/HeaderNavigation";
import FooterComponent from "../components/Footer";
import { useState, useEffect } from "react";

export default function Home() {
  const [loginState, setLoginState] = useState(false);
  const checkLogIn = async () => {
    const l = await checkLoggedIn();
    setLoginState(l);
  };

  useEffect(function () {
    checkLogIn();
  }, []);

  return (
    <div>
      <HeaderComponent loggedinState={loginState} />
      <hr />

      <NavigationComponent />

      <hr />
      <div
        className={`md:h-screen flex flex-col md:flex-row justify-between items-center gap-x-10 w-full px-4 my-10 py-8 mt-[20%] md:mt-0`}
      >
        <div
          className={`h-[200px] w-[200px] xl:h-[500px] xl:w-[500px] 2xl:h-[600px] 2xl:w-[600px] md:block my-auto`}
        >
          <Image
            src={"/images/Contact us-amico 1.png"}
            layout={"intrinsic"}
            alt="none"
            width={800}
            height={800}
            className="w-[100%] h-[100%]"
          />
          <div className="hidden md:block">
            <div className={`text-center`}>OR</div>
            <div className={`text-center`}>bartcashsupport@gmail.com</div>
          </div>
        </div>
        <div
          className={`mx-auto py-4 flex flex-col text-center justify-center w-11/12 md:w-6/12 xl:w-4/12`}
        >
          <div className={`font-bold text-l md:text-left text-[40px] mt-2`}>
            Contact Us
          </div>
          <div className={`text-l md:text-left text-[16px] my-4`}>
            Want to contact us, submit your questions here and we will get back
            to you as soon as possible
          </div>

          <div className={`flex text-left mb-1 flex-col`}>
            <label className={`mb-1`}>Name</label>
            <input
              placeholder="Enter name"
              onChange={(e) => {
                setName(e.target.value);
              }}
              type={`text`}
              className={`border rounded-[10px] p-2 mb-4 w-full`}
            />
          </div>

          <div className={`flex text-left mb-2 flex-col`}>
            <label className={`mb-1`}>Email</label>
            <div className={`flex flex-row items-center`}>
              <input
                placeholder="Enter email"
                type={`text`}
                className={`border rounded-[10px]  p-2 mb-4 w-full`}
              />
            </div>
          </div>

          <div className={`flex text-left mb-2 flex-col`}>
            <label className={`mb-1`}>Phone Number</label>
            <div className={`flex flex-row items-center`}>
              <input
                placeholder="Enter phone number"
                type={`text`}
                className={`border rounded-[10px]  p-2 mb-4 w-full`}
              />
            </div>
          </div>

          <div className={`flex text-left mb-2 flex-col`}>
            <label className={`mb-1`}>Message</label>
            <div className={`flex flex-row items-center`}>
              <textarea
                className={`border rounded-[10px]  p-2 mb-4 w-full`}
                placeholder="Write message"
              ></textarea>
            </div>
          </div>

          {/* <div className={`flex text-left mb-2 flex-col`}>
                    <label className={`mb-1`}>Email</label>
                    <input placeholder='Enter email' type={`email`} onChange={(e) => {setEmail(e.target.value)}} className={`border rounded-[10px] p-2 mb-4 w-full`} />
                </div>

                <div className={`flex text-left mb-2 flex-col`}>
                    <label className={`mb-1`}>Password</label>
                    <input placeholder='Enter password' type={`password`} onChange={(e) => {setPassword(e.target.value)}} className={`border rounded-[10px] p-2 mb-4 w-full`} />
                </div>

                <div className={`flex text-left mb-2 flex-col`}>
                    <label className={`mb-1`}>Confirm Password</label>
                    <input placeholder='Enter password again' type={`password`} onChange={(e) => {setConfirmPassword(e.target.value)}} className={`border rounded-[10px] p-2 mb-4 w-full`} />
                </div> */}

          <button
            className={`p-2 px-8 text-white bg-primary text-sm rounded-[10px] w-fit mx-auto mb-4`}
          >
            Submit
          </button>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
}
